var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('v-app-bar',{attrs:{"dark":"","dense":"","color":"bluePcm"}},[_c('ClientNameAppbar'),_c('v-spacer'),_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"icon":"","color":"orangePcm"},on:{"click":_vm.logoff}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v("mdi-power-standby")])],1)]}}])},[_c('span',[_vm._v("Deslogar")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }